import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO/SEO';
import { ServiceSchema, BreadcrumbSchema } from '../components/SEO/StructuredData';
import ServicePage from '../components/ServicePage/ServicePage';

// Import Smart Home images
import emsImage from '../assets/images/services/it/EMS.jpg';
import ems1Image from '../assets/images/services/it/EMS1.jpg';

// Import IT Security video (can be reused for Smart Home)
import itVideo from '../assets/videos/services/IT_Security.mp4';

// Import benefits image
import smartHomeBenefitsImage from '../assets/images/services/it/EMS.jpg';

const SmartHomePage: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <>
      <SEO title="Smart Home Solutions" description="Smart home automation systems in DRC. Energy management, home automation, and intelligent control systems by Cool & Care." keywords="smart home DRC, home automation, energy management, intelligent control Kinshasa" />
      <ServiceSchema name="Smart Home Solutions" description="Smart home automation with energy management and intelligent control systems." url="/smart-home" />
      <BreadcrumbSchema items={[{ name: 'Services', url: '/services' }, { name: 'Smart Home', url: '/smart-home' }]} />
      <ServicePage
        serviceName={t('servicePage.services.smartHome.name')}
      serviceDescription={t('servicePage.services.smartHome.description')}
      videoUrl={itVideo}
      productImages={[
        emsImage,
        ems1Image
      ]}
      features={t('servicePage.services.smartHome.features', { returnObjects: true }) as string[]}
      benefits={t('servicePage.services.smartHome.benefits', { returnObjects: true }) as string[]}
      benefitsImage={smartHomeBenefitsImage}
    />
    </>
  );
};

export default SmartHomePage;
